
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">Resolve Error</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div>
      <div>This will resolve the error and it will NOT show in the transaction log.</div>
    </div>
    <div class="modal-footer mt-4">
      <button type="button" class="btn btn-success" data-dismiss="modal" (click)="accept()">Mark as Resolved</button>
      <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
